<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#94FF89" />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { pushToDataLayer } from '~/composables/useTracking';
import { useCartStore } from '~/store/cart';

const uiStore = useUiStore();
const cartStore = useCartStore();

/**
 * Navigation guard
 */
const router = useRouter();
router.beforeEach(() => {
  document.body.classList.remove('locked');
  uiStore.tempErrorMsg = '';
  cartStore.showCartMenu = false;
  cartStore.showAddedItem = false;
});

onMounted(()=> {
  pushToDataLayer({
    event: 'originalLocation',
    originalLocation: window.location.href,
  });
});
</script>
